import type { ProgressReport } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ProgressReportStore } from '../model/store/interfaces'

import { useDisciplineStore } from '@entities/customer/@x/progress-report'
import { entryData } from '@shared/lib/scope'

export const getReport = (state: ProgressReportStore): ProgressReport | null =>
  entryData(state.reportById, useDisciplineStore().activeDiscipline?.id ?? null)

export const getReportTitle = (report: { number: ProgressReport['number'] | null } | null): string => {
  return report?.number
    ? `Progress Report #${report.number}`
    : 'Progress Report'
}

export const report = {
  getReport: (state: ProgressReportStore): ProgressReport | null => getReport(state),
  isReport: (state: ProgressReportStore): boolean => !!getReport(state),
  getNumber: (state: ProgressReportStore): ProgressReport['number'] | null => getReport(state)?.number ?? null,
  getTitle: (state: ProgressReportStore): string => getReportTitle(getReport(state)),
}
